import React, { Component } from "react";
import { CRUDFunction } from "../../../../reduxCURD/container";
import { deriveCRUDNames } from "../../crudHelpers";
import GroupedBarChart from "./Chart";
import PropagateLoader from "react-spinners/PropagateLoader";
import { themeService } from "../../../../theme/service/activeTheme.service";
class BarGraphSummaryWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      spinnerLoading: false,
    };

    const { widgetId } = this.props.settings;
    this.crudNames = deriveCRUDNames(widgetId);
  }
  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      if (!filterLocations) return { ...s };
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getBarGraphSummaryWidgets(url);
    this.props.createBarGraphSummaryWidget(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }
  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations } = this.props;
    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps, prevState) {
    const { settings } = this.props.settings;
    const { dateRange, barGraphSummaryWidgets, actionType, filterLocations } = this.props;

    if (this.props.actionType === "BARGRAPHSUMMARYWIDGET_CREATE_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }
    const dateChanged = dateRange.month !== prevProps.dateRange.month || dateRange.year !== prevProps.dateRange.year;
    if (dateChanged || filterLocations !== prevProps.filterLocations) {
      this.fetchCall(settings, dateRange, filterLocations);
    }
    if (actionType === "BARGRAPHSUMMARYWIDGET_CREATE_SUCCESS" && prevProps.actionType !== this.props.actionType) {
      this.setState({
        data: barGraphSummaryWidgets,
        spinnerLoading: false,
      });
    }
    if (this.props.actionType === "BARGRAPHSUMMARYWIDGET_CREATE_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false });
    }
  }
  getDataForChart() {
    const { data } = this.state;
    const { filterLocations } = this.props;

    if (
      !data ||
      !data.inspectionSummary ||
      !data.inspectionSummary.lines ||
      !data.maintenanceSummary ||
      !data.maintenanceSummary.lines ||
      !data.executionSummary ||
      !data.executionSummary.lines
    ) {
      return [];
    }
    const { inspectionSummary, maintenanceSummary, executionSummary } = data;
    const summary = [];

    for (let i = 0; i < filterLocations.length; i++) {
      const lineId = filterLocations[i];

      const inspectionLine = inspectionSummary.lines[lineId];
      const executionLine = executionSummary.lines[lineId];
      const maintenanceLine = maintenanceSummary.lines[lineId];
      const location =
        (inspectionLine && inspectionLine.lineInfo && inspectionLine.lineInfo.lineName) ||
        (executionLine && executionLine.lineInfo && executionLine.lineInfo.lineName) ||
        (maintenanceLine && maintenanceLine.lineInfo && maintenanceLine.lineInfo.lineName);
      if (location) {
        const inspections = inspectionLine && inspectionLine.summary ? inspectionLine.summary.total : 0;
        const executions = executionLine && executionLine.summary ? executionLine.summary.performed : 0;
        const maintenance = maintenanceLine && maintenanceLine.summary ? maintenanceLine.summary.workOrdersCreated : 0;

        summary.push({
          inspections,
          executions,
          maintenance,
          location,
        });
      }
    }

    return summary;
  }

  render() {
    let { data, spinnerLoading } = this.state;
    let chartData = this.getDataForChart();
    if (spinnerLoading || !data) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }
    return (
      <div style={{ backgroundColor: "white", padding: "20px", height: "100%" }}>
        <div md="12">{data && <GroupedBarChart data={chartData || []} />}</div>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const BarGraphSummaryWidgetContainer = CRUDFunction(BarGraphSummaryWidget, "barGraphSummaryWidget", actionOptions, null, [], "dashboard");
export default BarGraphSummaryWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/barGraphWidget/BarGraphSummaryWidget.jsx